import ENVIRONMENT from './environment';

const { BASE_URL } = ENVIRONMENT;

/**
 * Central registry of backend endpoints.
 * Grouped by domain. Every value is built from BASE_URL.
 */
const apiRoutes = {
  BASE_URL,

  // ---------------------------------------------------------------------------
  // Auth & session
  // ---------------------------------------------------------------------------
  LOGIN: `${BASE_URL}/auth/login`,
  CONTACT_REGISTER: `${BASE_URL}/auth/contact-register`,
  RESET_EMAIL: `${BASE_URL}/auth/password/email`,
  RESET_PASSWORD: `${BASE_URL}/auth/reset-password`,
  USER_INFO: `${BASE_URL}/auth/user`,
  USER_ACTIVITY_STATUS: `${BASE_URL}/auth/user/activity-status`,
  API_TOKENS: `${BASE_URL}/auth/api-tokens`,

  // ---------------------------------------------------------------------------
  // Users & assignees
  // ---------------------------------------------------------------------------
  USERS: `${BASE_URL}/auth/users`,
  PROJECT_USERS: `${BASE_URL}/projects/users`,
  ASSIGNEES: `${BASE_URL}/projects/assignees`,

  // ---------------------------------------------------------------------------
  // Access control
  // ---------------------------------------------------------------------------
  GROUPS: `${BASE_URL}/groups`,

  // ---------------------------------------------------------------------------
  // Layout chrome (search, counters, preloaded resources)
  // ---------------------------------------------------------------------------
  GLOBAL_SEARCH: `${BASE_URL}/global-search`,
  COUNTERS: `${BASE_URL}/resources/counters`,
  CHECKLISTS: `${BASE_URL}/resources/checklists`,
  REQUEST_FORMS: `${BASE_URL}/resources/request-forms`,

  // ---------------------------------------------------------------------------
  // Customers & contacts
  // ---------------------------------------------------------------------------
  CUSTOMERS: `${BASE_URL}/billing/customers`,
  STRIPE_CUSTOMERS: `${BASE_URL}/customers`,
  CUSTOMER_INVITE: `${BASE_URL}/billing/customer-invitations`,
  CONTACTS: `${BASE_URL}/billing/contacts`,

  // ---------------------------------------------------------------------------
  // Projects (plans)
  // ---------------------------------------------------------------------------
  PROJECTS: `${BASE_URL}/projects/projects`,
  PROJECTS_LITE: `${BASE_URL}/projects/projects-lite`,
  PLANS: `${BASE_URL}/projects/plans`,
  PROJECT_TIME_REPORT: `${BASE_URL}/projects/projects-time-report`,

  // ---------------------------------------------------------------------------
  // Tasks
  // ---------------------------------------------------------------------------
  PROJECT_TASKS: `${BASE_URL}/projects/tasks`,
  PROJECT_TASKS_TREE: `${BASE_URL}/projects/tasks/tree`,
  TAGS: `${BASE_URL}/tags`,

  // ---------------------------------------------------------------------------
  // Requests
  // ---------------------------------------------------------------------------
  REQUESTS: `${BASE_URL}/projects/requests`,

  // ---------------------------------------------------------------------------
  // Comments, reactions & mentions
  // ---------------------------------------------------------------------------
  COMMENTS: `${BASE_URL}/comments`,
  REACTION: `${BASE_URL}/reaction`,
  MENTIONS: `${BASE_URL}/mentions`,
  MENTIONS_SENT: `${BASE_URL}/mentions/sent`,
  MENTIONS_SCHEDULED: `${BASE_URL}/mentions/scheduled`,
  INBOX: `${BASE_URL}/mentions/inbox`,
  PENDING_RESPONSES_INBOX: `${BASE_URL}/pending-responses/inbox`,
  PENDING_RESPONSES_COUNT: `${BASE_URL}/pending-responses/count`,

  // ---------------------------------------------------------------------------
  // Time tracking (V2)
  // ---------------------------------------------------------------------------
  TIME_ENTRIES: `${BASE_URL}/v2/projects/time-entries`,
  TIMERS: `${BASE_URL}/v2/projects/timers`,
  TIMERS_CURRENT: `${BASE_URL}/v2/projects/timers/current`,
  TIMERS_START: `${BASE_URL}/v2/projects/timers/start`,
  CLOCK_REPORT: `${BASE_URL}/v2/projects/time-entries/clock-report`,
  USER_PERFORMANCE: `${BASE_URL}/v2/projects/reports/user-performance`,

  // ---------------------------------------------------------------------------
  // Reports
  // ---------------------------------------------------------------------------
  REPORT_OVERDUE: `${BASE_URL}/report-overdue`,
  REPORT_TASK_OVERDUE: `${BASE_URL}/report-task-overdue`,

  // ---------------------------------------------------------------------------
  // Content (blog)
  // ---------------------------------------------------------------------------
  POSTS: `${BASE_URL}/blog/posts`,
  POST_CATEGORIES: `${BASE_URL}/blog/categories`,
  POST_TAGS: `${BASE_URL}/blog/tags`,

  // ---------------------------------------------------------------------------
  // Uploads & downloads
  // ---------------------------------------------------------------------------
  CREATE_PRE_SIGNED: `${BASE_URL}/create-pre-signed-url`,
  UPLOADS: `${BASE_URL}/uploads`,
  MASS_DOWNLOAD: `${BASE_URL}/mass-download`,

  // ---------------------------------------------------------------------------
  // Billing & payments
  // ---------------------------------------------------------------------------
  STRIPE_OVERDUE_INVOICES: `${BASE_URL}/stripe/overdue-invoices`,

  // ---------------------------------------------------------------------------
  // Survey
  // ---------------------------------------------------------------------------
  SURVEY_FEEDBACK: `${BASE_URL}/survey-feedback`,

  // ---------------------------------------------------------------------------
  // Notifications
  // ---------------------------------------------------------------------------
  NOTIFICATIONS: `${BASE_URL}/notifications`,
  FCM_TOKEN: `${BASE_URL}/fcm-token`,

  // ---------------------------------------------------------------------------
  // Bulk operations
  // ---------------------------------------------------------------------------
  BULK_OPERATION: `${BASE_URL}/bulk-operation`,
};

export default apiRoutes;
